"use client";

import { useState } from "react";

export default function ImageGenerator() {
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState("");
  const [prompt, setPrompt] = useState("");
  const [style, setStyle] = useState("Anime");
  const [error, setError] = useState("");
  const [validationError, setValidationError] = useState("");

  const validateForm = () => {
    if (!prompt.trim()) {
      setValidationError("Por favor, digite um prompt para gerar a imagem.");
      return false;
    }
    if (prompt.trim().length < 3) {
      setValidationError("O prompt deve ter pelo menos 3 caracteres.");
      return false;
    }
    setValidationError("");
    return true;
  };

  const handleGenerate = async () => {
    if (!validateForm()) return;
    
    setLoading(true);
    setImage("");
    setError("");
    try {
      const response = await fetch("/api/generate-image", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prompt, style }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Falha ao gerar a imagem");
      }

      setImage(`data:image/png;base64,${data.imageBase64}`);
    } catch (error: any) {
      console.error(error);
      setError(error.message || "Falha ao gerar a imagem. Por favor, tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-secondary p-8 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4 text-green-400">🎨 GERADOR DE IMAGENS IA</h2>
      <div className="flex flex-col gap-4">
        <input
          type="text"
          placeholder="Descreva a imagem que deseja criar..."
          className={`bg-primary text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 font-mono ${
            validationError ? "border-2 border-red-500" : ""
          }`}
          value={prompt}
          onChange={(e) => {
            setPrompt(e.target.value);
            setValidationError("");
          }}
        />
        <select
          className="bg-primary text-white p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 font-mono"
          value={style}
          onChange={(e) => setStyle(e.target.value)}
        >
          <option>Estilo Visual</option>
          <option>Anime</option>
          <option>Cyberpunk</option>
          <option>Realista</option>
          <option>Render 3D</option>
        </select>
        {validationError && (
          <p className="text-red-500 text-sm font-mono">⚠️ {validationError}</p>
        )}
        <button
          className="bg-green-500 hover:bg-green-600 text-black font-bold py-3 px-4 rounded transition-transform transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed font-mono"
          onClick={handleGenerate}
          disabled={loading || !prompt.trim()}
        >
          {loading ? "🔄 PROCESSANDO..." : "🚀 GERAR IMAGEM"}
        </button>
        <div className="mt-8 bg-primary rounded-lg p-4 h-96 flex items-center justify-center border border-green-500/30">
          {loading && (
            <div className="flex flex-col items-center">
              <div className="spinner border-green-400"></div>
              <p className="mt-4 text-green-400 font-mono">🔥 Gerando imagem...</p>
            </div>
          )}
          {image && (
            <div className="relative w-full h-full flex items-center justify-center">
              <img src={image} alt="Generated" className="max-h-full max-w-full rounded-lg border border-green-500/50" />
              <button
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = image;
                  link.download = 'generated-image.png';
                  link.click();
                }}
                className="absolute top-2 right-2 bg-green-500 hover:bg-green-600 text-black p-2 rounded-lg transition-colors"
                title="Baixar imagem"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </button>
            </div>
          )}
          {error && (
            <div className="text-center">
              <p className="text-red-500 mb-2 font-mono">❌ {error}</p>
              <button
                onClick={handleGenerate}
                className="bg-green-500 hover:bg-green-600 text-black px-4 py-2 rounded transition-colors font-mono"
              >
                🔄 TENTAR NOVAMENTE
              </button>
            </div>
          )}
          {!loading && !image && !error && (
            <p className="text-gray-400 font-mono">💡 Sua imagem criada pela IA aparecerá aqui</p>
          )}
        </div>
      </div>
    </div>
  );
}
